module.exports = __webpack_public_path__ + "static/media/Ellipse 1.63fd3f7a.jpeg";